export default __webpack_public_path__ + "static/media/yucebey3.05b687c2.jpg";